__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "layout";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "3.16.0", () => (__webpack_require__.e(277).then(() => (() => (__webpack_require__(4277))))));
			register("@azure/msal-react", "2.0.18", () => (Promise.all([__webpack_require__.e(375), __webpack_require__.e(641), __webpack_require__.e(100)]).then(() => (() => (__webpack_require__(375))))));
			register("@fluentui/react-components", "9.73.8", () => (Promise.all([__webpack_require__.e(886), __webpack_require__.e(708), __webpack_require__.e(142), __webpack_require__.e(729), __webpack_require__.e(641), __webpack_require__.e(163), __webpack_require__.e(763), __webpack_require__.e(992), __webpack_require__.e(45), __webpack_require__.e(111)]).then(() => (() => (__webpack_require__(9142))))));
			register("@fluentui/react-portal", "9.8.12", () => (Promise.all([__webpack_require__.e(886), __webpack_require__.e(641), __webpack_require__.e(163), __webpack_require__.e(763), __webpack_require__.e(32)]).then(() => (() => (__webpack_require__(9032))))));
			register("@fluentui/react-provider", "9.22.16", () => (Promise.all([__webpack_require__.e(886), __webpack_require__.e(708), __webpack_require__.e(641), __webpack_require__.e(128), __webpack_require__.e(763), __webpack_require__.e(992), __webpack_require__.e(45), __webpack_require__.e(40)]).then(() => (() => (__webpack_require__(2756))))));
			register("@fluentui/react-shared-contexts", "9.26.2", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(138)]).then(() => (() => (__webpack_require__(6138))))));
			register("@fluentui/react-theme", "9.2.1", () => (__webpack_require__.e(350).then(() => (() => (__webpack_require__(6350))))));
			register("@fluentui/react", "8.115.6", () => (Promise.all([__webpack_require__.e(740), __webpack_require__.e(980), __webpack_require__.e(641), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(3740))))));
			register("@fluentui/tokens", "1.0.0-alpha.23", () => (__webpack_require__.e(658).then(() => (() => (__webpack_require__(3658))))));
			register("@griffel/core", "1.20.1", () => (__webpack_require__.e(137).then(() => (() => (__webpack_require__(137))))));
			register("@griffel/react", "1.6.1", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(128), __webpack_require__.e(787)]).then(() => (() => (__webpack_require__(3787))))));
			register("@offer/store", "1.0.0", () => (Promise.all([__webpack_require__.e(287), __webpack_require__.e(839)]).then(() => (() => (__webpack_require__(1220))))));
			register("@tanstack/react-query", "5.51.21", () => (Promise.all([__webpack_require__.e(777), __webpack_require__.e(641), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(2158))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.22.1", () => (Promise.all([__webpack_require__.e(955), __webpack_require__.e(641), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "18.2.0", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
			register("zustand", "4.5.1", () => (Promise.all([__webpack_require__.e(641), __webpack_require__.e(64)]).then(() => (() => (__webpack_require__(3064))))));
			initExternal(3881);
			initExternal(857);
			initExternal(6149);
			initExternal(3437);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};